module.exports = __webpack_public_path__ + "img/longer-days-belong-to-play-mobile.jpg";